import Axios from "axios";
import token from "./setToken";

export default {
  async makeAnswerSheet(surveyId, memberNo, targetMonth) {
    try {
      let params = new URLSearchParams();
      params.append("surveyId", JSON.stringify(surveyId));
      params.append("memberNo", JSON.stringify(memberNo));
      params.append("targetMonth", JSON.stringify(targetMonth));
      return await Axios.post(`/api/CreateCityDataAnswerSheet`,params,  token.setTokenToHeader());
    } catch (error) {
      console.error("月次報告(8号・9号・輸入品)回答票を作成できません[exportSurvey]");
      throw error;
    }
  },
};
